//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoTooltipAlignment from './demos/DemoTooltipAlignment.vue'
import DemoTooltipColor from './demos/DemoTooltipColor.vue'
import DemoTooltipEvent from './demos/DemoTooltipEvent.vue'
import DemoTooltipVModal from './demos/DemoTooltipVModal.vue'
import DemoTooltipTransition from './demos/DemoTooltipTransition.vue'
import DemoTooltipVariousElements from './demos/DemoTooltipVariousElements.vue'
import DemoTooltipDelay from './demos/DemoTooltipDelay.vue'

// code
import {
  tooltipAlignment,
  tooltipColor,
  tooltipEvent,
  tooltipVModal,
  tooltipTransition,
  tooltipVariousElements,
  tooltipDelay,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoTooltipAlignment,
    DemoTooltipColor,
    DemoTooltipEvent,
    DemoTooltipVModal,
    DemoTooltipTransition,
    DemoTooltipVariousElements,
    DemoTooltipDelay,
  },
  setup() {
    return {
      codeSnippets: {
        tooltipAlignment,
        tooltipColor,
        tooltipEvent,
        tooltipVModal,
        tooltipTransition,
        tooltipVariousElements,
        tooltipDelay,
      },
    }
  },
}
